module.exports = __webpack_public_path__ + "img/block-1920.0da4facf.jpg";